import { taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { token, Button } from '@zillow/constellation';
import { motion } from 'framer-motion';
import { yieldCallback } from '@zillow/yield-callback';

var _templateObject, _templateObject2;
var HtmlToReact = require('html-to-react');
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser();
var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
var TabButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-1wlodno-0"
})(["position:relative;&:hover:not(:disabled){background-color:transparent;}&:focus{box-shadow:none;}", ""], function (props) {
  return props.isActive ? css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n                  &:hover:not(:disabled) {\n                      /* Disable the dark text color on hover if active */\n                      color: ", ";\n                  }\n              "])), token('colors.brand')) : css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n                  color: ", ";\n              "])), token('colors.linkActive'));
});
var Underline = /*#__PURE__*/styled(motion.div).withConfig({
  componentId: "sc-1wlodno-1"
})(["background-color:", ";height:3px;border-radius:3px;width:100%;position:absolute;bottom:0;"], token('colors.brand'));
var UNDERLINE_TRANSITION = {
  layout: {
    duration: 0.2,
    ease: 'easeOut'
  }
};
var CarouselTab = function CarouselTab(_ref) {
  var isActive = _ref.isActive,
    onClick = _ref.onClick,
    children = _ref.children;
  var processingInstructions = [{
    shouldProcessNode: function shouldProcessNode() {
      return true;
    },
    processNode: processNodeDefinitions.processDefaultNode
  }];
  var parsedChildren = htmlToReactParser.parseWithInstructions(children, function () {
    return true;
  }, processingInstructions);
  return /*#__PURE__*/React.createElement(TabButton, {
    bare: true,
    isActive: isActive,
    onClick: yieldCallback(function () {
      return onClick();
    })
  }, parsedChildren, isActive && /*#__PURE__*/React.createElement(Underline, {
    layout: true,
    transition: UNDERLINE_TRANSITION,
    layoutId: "underline"
  }));
};
CarouselTab.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired
} : {};
CarouselTab.defaultProps = {
  isActive: PropTypes.boolean
};
var CarouselTab$1 = CarouselTab;

export { CarouselTab$1 as default };
